import { useDashboardIdentity } from './useDashboardIdentity';
import { useQuery } from '@tanstack/react-query';
import type { ChargerUptimeResponse } from '@evi/shared';
import { fetchChargerUptime } from '@/lib/api';

/**
 * Charger uptime widget data hook. 60s poll matches the server-
 * side TTL cache; pinger and pollee align so we don't burn
 * extra DB work between cache refreshes.
 */
export function useChargerUptime() {
  const identity = useDashboardIdentity();
  return useQuery<ChargerUptimeResponse>({
    queryKey: ['dashboard', identity, 'charger-uptime'],
    queryFn: () => fetchChargerUptime(),
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}
